import React from 'react';
import { string } from 'prop-types';
import { Link, Route } from 'react-router-dom';

export default class NavLink extends React.Component {
  static propTypes = {
    label: string.isRequired,
    to: string.isRequired
  };

  getLinkClass = (path, match) =>
    match && match.url === path ? 'nav__link--active' : 'nav__link';

  getLink = ({ match }) => {
    const { to, label } = this.props;
    return (
      <Link className={this.getLinkClass(to, match)} to={to}>
        {label}
      </Link>
    );
  };

  render() {
    return (
      <li role="presentation">
        <Route path={this.props.to} exact children={this.getLink} />
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Nav/NavLink.js